import { FormFieldProps, FormTextType } from './type'
import { Textarea } from '@/components/ui/textarea'
import { useFormContext } from 'react-hook-form'

function resolveTextValue(value: unknown) {
  if (value == null) {
    return ''
  }
  if (typeof value === 'string') {
    return value
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value)
  }
  try {
    return JSON.stringify(value, null, 2)
  } catch {
    return String(value)
  }
}

export const FormTextField = ({
  data,
  field,
}: FormFieldProps<FormTextType>) => {
  const { getValues } = useFormContext()

  const displayValue = data.resolver
    ? data.resolver(getValues())
    : field.value

  return (
    <Textarea
      {...field}
      value={resolveTextValue(displayValue)}
      className="leading-5 disabled:opacity-75"
      disabled={data.readOnly}
      placeholder={data.placeholder || data.label}
      style={{
        height: data.height,
      }}
      defaultValue={data.default}
    />
  )
}
